import { Icon, Table } from '@octano/global-ui';
import { Badge, Col, Row } from 'reactstrap';
import { useProcessColumns } from '../hooks/useProcessColumns';
import { useCallback, useMemo, useState } from 'react';
import OffersList from './OffersList';
import { useProcessList } from './ProcessListLoader';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../locales/translations';
import ProcessListEditModal from './ProcessListEditModal';
import { Process } from '../types';

export default function ProcessList() {
  const { data } = useProcessList();
  const { t } = useTranslation(TranslationsKeys.CONFIGURATION_ACADEMIC_OFFER);

  const [openEditProcess, setOpenEditProcess] = useState<{
    process?: Process;
    open: boolean;
  }>({ open: false });

  const toggleEditProcess = useCallback(
    (process?: any) => {
      setOpenEditProcess({ process, open: !openEditProcess.open });
    },
    [openEditProcess.open],
  );

  const columns = useProcessColumns({ toggleEditProcess });

  const texts = useMemo(() => {
    return {
      noProcesses: t('processList.noProcesses'),
    };
  }, [t]);

  const [openOffers, setOpenOffers] = useState<{
    key: string;
    open: boolean;
  }>({ key: '', open: false });

  const handleOpenOffers = useCallback(
    (key: string) => {
      if (openOffers.key === key) {
        setOpenOffers({ key, open: !openOffers.open });
      } else {
        setOpenOffers({ key, open: true });
      }
    },
    [openOffers],
  );

  return (
    <Row className="mt-4">
      {data?.length ? (
        data.map(({ subprocess, ...process }, index) => (
          <Col key={index} xs={12} className="p-0">
            <Col xs={12} className="d-flex justify-content-between mb-3">
              <p className="fs-18 fw-600">
                {process.name} {index + 1}
              </p>
              <Badge
                color="primary"
                pill
                className="cursor-pointer"
                style={{
                  width: '25px',
                  height: '25px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
                onClick={() => handleOpenOffers(`${process.name}-${index}`)}
              >
                <Icon
                  name={
                    openOffers.key === `${process.name}-${index}` &&
                    openOffers.open
                      ? 'minus'
                      : 'plus'
                  }
                  color="white"
                />
              </Badge>
            </Col>
            <Col xs={12}>
              <Table columns={columns} data={[process]} striped />
            </Col>
            <Col xs={12} className="mb-5">
              <OffersList
                isOpen={
                  openOffers.key === `${process.name}-${index}` &&
                  openOffers.open
                }
                data={subprocess}
                process={process as Process}
              />
            </Col>
            {openEditProcess.open && (
              <ProcessListEditModal
                toggle={toggleEditProcess}
                process={openEditProcess.process as Process}
              />
            )}
          </Col>
        ))
      ) : (
        <Col xs={12}>
          <p>{texts.noProcesses}</p>
        </Col>
      )}
    </Row>
  );
}
